angular.module('shared').factory('CommunicationTemplateCategories', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params != null ? params.gymId : void 0).all('communication_template_categories');
}]);
